export default __webpack_public_path__ + "static/isometric-cards.url-91b536358b383216e207566684e56052.svg";